(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {

    const pendingKey = 'deedental:maxx_quote_pending';
    const publishQuoteSuccess = (attempt = 0) => {
      const context = document.querySelector('[data-maxx-quote]');
      if (!context || !document.querySelector('[data-maxx-quote-success]')) return;
      try {
        const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
        if (!pending || pending.model !== context.dataset.maxxQuote || Date.now() - pending.time > 3600000) return;
        if (!window.Shopify?.analytics?.publish) {
          if (attempt < 20) setTimeout(() => publishQuoteSuccess(attempt + 1), 500);
          return;
        }
        Shopify.analytics.publish('deedental:maxx_quote_submitted', {
          product_id: context.dataset.quoteProductId,
          product_handle: context.dataset.maxxQuote,
          lead_type: 'equipment_quote'
        });
        sessionStorage.removeItem(pendingKey);
      } catch (_) {}
    };
    document.addEventListener('submit', (event) => {
      const context = event.target.querySelector('[data-maxx-quote]');
      if (!context || !event.target.checkValidity()) return;
      try { sessionStorage.setItem(pendingKey, JSON.stringify({ model: context.dataset.maxxQuote, time: Date.now() })); } catch (_) {}
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => publishQuoteSuccess(), { once: true });
    else publishQuoteSuccess();
    const syncQuoteOptions = () => {
      document.querySelectorAll('[data-quote-product-id]').forEach((context) => {
        const productRoot = document.querySelector('product-info[data-product-id="' + context.dataset.quoteProductId + '"]');
        const field = context.querySelector('[data-quote-option]');
        if (!productRoot || !field) return;
        const values = Array.from(productRoot.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select, variant-radios input[type="radio"]:checked')).map((input) => input.value).filter(Boolean);
        if (!values.length) return;
        const selected = values.join(' / ');
        field.value = selected;
        const label = context.querySelector('[data-quote-option-label]');
        if (label && label.textContent !== selected) label.textContent = selected;
      });
    };
    document.addEventListener('change', (event) => {
      if (event.target.closest('variant-selects, variant-radios')) syncQuoteOptions();
    });
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#ContactForm"]');
      if (!link) return;
      syncQuoteOptions();
      const field = document.querySelector('#ContactForm-name');
      if (field) requestAnimationFrame(() => field.focus({ preventScroll: true }));
    });
    document.addEventListener('submit', (event) => {
      if (event.target.querySelector('[data-quote-product-id]')) syncQuoteOptions();
    }, true);
    document.addEventListener('shopify:section:load', syncQuoteOptions);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncQuoteOptions, { once: true });
    else syncQuoteOptions();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deedental-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dd-hero-slider')) {
 class DeeDentalHeroSlider extends HTMLElement {
  connectedCallback() {
   if (this.ddReady) return;
   this.ddReady = true;
   this.slides = Array.from(this.querySelectorAll('[data-dd-slide]'));
   this.dots = Array.from(this.querySelectorAll('[data-dd-go]'));
   this.index = 0;
   this.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-dd-next')) this.show(this.index + 1);
    if (button.hasAttribute('data-dd-prev')) this.show(this.index - 1);
    if (button.hasAttribute('data-dd-go')) this.show(Number(button.dataset.ddGo));
   });
   this.addEventListener('keydown', event => {
    if (!event.target.closest('.dd-slider-controls')) return;
    if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1); }
   });
   this.addEventListener('touchstart', event => { this.touchStart = [event.touches[0].clientX,event.touches[0].clientY]; }, { passive:true });
   this.addEventListener('touchend', event => {
    if (!this.touchStart) return;
    const dx=event.changedTouches[0].clientX-this.touchStart[0], dy=event.changedTouches[0].clientY-this.touchStart[1];
    if (Math.abs(dx)>65 && Math.abs(dx)>Math.abs(dy)*1.5) this.show(this.index+(dx<0?1:-1));
    this.touchStart=null;
   }, { passive:true });
  }
  show(index) {
   if (!this.slides.length) return;
   this.index=(index+this.slides.length)%this.slides.length;
   this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;});
   this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
   const counter=this.querySelector('.dd-slider-counter');
   if(counter)counter.textContent=(this.index+1)+' / '+this.slides.length;
  }
 }
 customElements.define('dd-hero-slider',DeeDentalHeroSlider);
}

if (!customElements.get('dd-brand-marquee')) {
 customElements.define('dd-brand-marquee', class extends HTMLElement {
  connectedCallback() {
   if (this.ddBrandsReady) return;
   this.ddBrandsReady=true;
   const button=this.querySelector('.dd-brands-pause');
   button.addEventListener('click',()=>{
    const paused=this.toggleAttribute('data-paused');
    button.setAttribute('aria-pressed',String(paused));
    button.setAttribute('aria-label',paused?button.dataset.resumeLabel:button.dataset.pauseLabel);
    button.querySelector('span').textContent=paused?'▶':'Ⅱ';
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
